import styled from "styled-components";

export const BookList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

export const BookListItem = styled.div`
  font-size: 1em;
  position: relative;
  transition: all 0.5s ease;
  padding: 12px 24px;
  cursor: pointer;
  color: ${props => props.theme.primaryText};
  flex: 1;
  &:hover {
    background-color: ${({ theme }) =>
      theme.darkMode ? theme.background : "#f2f2f2"};
  }

  &:focus {
    outline: 0;
  }

  ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.darkMode ? theme.background : "#f2f2f2"};

      ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: ${theme.primary};
        z-index: 1;
      }
    `};
`;

export const ChapterMenuDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 24px;
`;
